window.docShadow = {
  getElementById: selector => {
    return (
      document.getElementById(selector) ||
      (document.querySelector('player-emp')
        ? document.querySelector('player-emp').shadowRoot.getElementById(selector)
        : null)
    );
  },
  querySelector: selector => {
    return (
      document.querySelector(selector) ||
      (document.querySelector('player-emp')
        ? document.querySelector('player-emp').shadowRoot.querySelector(selector)
        : null)
    );
  },
  querySelectorAll: selector => {
    return document.querySelectorAll(selector).length > 0
      ? document.querySelectorAll(selector)
      : document.querySelector('player-emp')
      ? document.querySelector('player-emp').shadowRoot.querySelectorAll(selector)
      : null;
  },
  getElementsByClassName: selector => {
    return document.getElementsByClassName(selector).length > 0
      ? document.getElementsByClassName(selector)
      : document.querySelector('player-emp')
      ? document.querySelector('player-emp').shadowRoot.querySelectorAll(`.${selector}`)
      : null;
  },
  getElementsByTagName: selector => {
    return document.getElementsByTagName(selector).length > 0
      ? document.getElementsByTagName(selector)
      : document.querySelector('player-emp')
      ? document.querySelector('player-emp').shadowRoot.querySelectorAll(selector)
      : null;
  },
};



// WEBPACK FOOTER //
// ./src/utils/override.js